import React, { useState } from 'react'
import Image from 'next/legacy/image'

import Header from '@/components/newHeader/Header'
import FAQsAboutFinancing from '@/components/financingPuppy/Faqs'
import Footer from '@/components/newFooter/newFooter'
import FinancingModal from '@/components/apply/FinancingModal'
import BasicHeadSeo from '@/components/basicHeadSeo'
import Title from '@/components/Title'

import { useMediaQuery } from '@utils'
import { FINANCING_CARDS, ROBOTS_META, WHY_A_PLAN } from 'const'

import styles from './payLater.module.scss'
import TextBody from '@/components/TextBody/TextBody'

const Partners = () => {
  const isTablet = useMediaQuery('(max-width:1270px)')
  const [showFinancingModal, setShowFinancingModal] = useState(null)

  return (
    <section className={styles.financingOptions}>
      <div className={styles.container}>
        <Title variant="h2">Meet Our Financing Partners</Title>

        <div className={styles.cards}>
          {FINANCING_CARDS.map((card) => (
            <div key={card.id} className={styles.card}>
              <div>
                <div className={styles.imageLogo}>
                  <Image
                    width={isTablet ? 120 : 70}
                    height={isTablet ? 20 : 10}
                    src={card.img}
                    objectFit="contain"
                    layout="responsive"
                    alt="Financing logo"
                  />
                </div>

                <div className={styles.items}>
                  {card.bullets.map((bullet, index) => (
                    <div key={index} className={styles.item}>
                      <img
                        src="/financings/checkbox-green.svg"
                        alt="Checkbox green"
                      />
                      <span>
                        <b>{bullet.title}</b>
                        <br />
                        {bullet.description}
                      </span>
                    </div>
                  ))}
                </div>

                <p className={styles.notes}>{card.legal}</p>
              </div>

              <div className={styles.buttonWrapper}>
                <button onClick={() => setShowFinancingModal(card.modal)}>
                  Learn more
                </button>
              </div>
            </div>
          ))}

          {showFinancingModal && (
            <FinancingModal
              isOpen={!!showFinancingModal}
              onClose={() => setShowFinancingModal(null)}
              option={showFinancingModal}
            />
          )}
        </div>
      </div>
    </section>
  )
}

export default function PuppyFinancing() {
  const isTablet = useMediaQuery('(max-width:1270px)')

  return (
    <>
      <BasicHeadSeo
        title="Puppy Financing & Payment Plans | MawooPets.com"
        description="Mawoo Pets is one of the best options for puppy financing solutions. We offer financing with no credit check, starting from 0% interest rate. Explore options now!"
        url={`${process.env.NEXT_PUBLIC_ROOT_URL}/puppy-financing`}
        image={`${process.env.NEXT_PUBLIC_ROOT_URL}/mawoo_social_1600x906.png`}
        content={ROBOTS_META}
      />

      <main className={styles.main}>
        <Header />
        <div className={styles.content}>
          <section className={styles.sectionHeader}>
            <Title variant="h1">Puppy Financing & Payment Plans</Title>

            <TextBody size="l">
              Flexible payment options to make your new best friend affordable.
            </TextBody>
          </section>
        </div>

        <Partners />

        <div className={styles.content}>
          <section className={styles.why}>
            <Title variant="h2">Why Choose a Puppy Payment Plan</Title>

            <div className={styles.container}>
              {WHY_A_PLAN.map((item, index) => (
                <div key={index} className={styles.step}>
                  <Title variant="h3">{item.title}</Title>
                  <p className={styles.text}>{item.description}</p>
                  {/* this is only for mobile */}
                  {index < WHY_A_PLAN.length - 1 && (
                    <div className={styles.line} />
                  )}
                </div>
              ))}
            </div>
          </section>

          <section className={styles.details}>
            <div className={styles.data}>
              <h2>Ready to Welcome Your New Friend?</h2>

              <p>
                Getting a new puppy from a good breeder is more than just a
                purchase — it's the start of a new relationship that'll be
                filled with kisses and tail wags. With our flexible payment
                options, we're here to make the financial part of that journey
                easier for you. Delve into our financing options today and
                discover how it may help you bring home the love you've been
                waiting for.
                <br />
                <br />
                If you have any questions or need further guidance, please call
                our team at <b>1 (888) 488-7203.</b> We're here to help. We're
                excited to be a part of your journey, every paw-step of the way.
              </p>
            </div>

            <div className={styles.image}>
              <Image
                width={isTablet ? 350 : 500}
                height={isTablet ? 300 : 400}
                src="/financings/woman-with-your-puppy.svg"
                layout="fixed"
                alt="Woman hugging her puppy"
                quality={100}
              />
            </div>
          </section>

          <section className={styles.faqs}>
            <Title variant="h1-small">FAQs About Puppy Financing</Title>
            <FAQsAboutFinancing />
          </section>
        </div>
        <Footer />
      </main>
    </>
  )
}
